export const SECTION_TITLE = {
  about: 'Обо мне',
  main: 'Основная информация',
  additional: 'Дополнительно',
};

export const HEADER_ACTION_KEY = {
  add: 'add',
  edit: 'edit',
  done: 'done',
};

export const HEADER_ACTION = {
  [HEADER_ACTION_KEY.add]: {
    icon: '$iplus-outline',
    color: 'redesignPrimaryDarken',
    title: 'Добавить',
  },
  [HEADER_ACTION_KEY.edit]: {
    icon: '$ipencil',
    color: 'redesignPrimaryDarken',
    title: 'Редактировать',
  },
  [HEADER_ACTION_KEY.done]: {
    color: 'redesignSecondary',
    title: 'Готово',
  },
};

export const ROW_LABEL_KEY = {
  success: 'success',
  warning: 'warning',
};

export const ROW_LABEL = {
  [ROW_LABEL_KEY.success]: {
    color: 'redesignSuccess',
    textColor: 'white',
  },
  [ROW_LABEL_KEY.warning]: {
    color: 'redesignWarning',
    textColor: 'redesignBlack',
  },
};

export const ROW_ACTION_KEY = {
  indicate: 'indicate',
  change: 'change',
  link: 'link',
  unlink: 'unlink',
  upload: 'upload',
  confirm: 'confirm',
  date: 'date',
  reset: 'reset',
};

export const ROW_ACTION = {
  [ROW_ACTION_KEY.indicate]: {
    icon: '$iplus-outline',
    color: 'redesignPrimaryDarken',
    title: 'Указать',
  },
  [ROW_ACTION_KEY.change]: {
    color: 'redesignPrimaryDarken',
    icon: '$ipencil',
    title: 'Изменить',
  },
  [ROW_ACTION_KEY.link]: {
    icon: '$iplus-outline',
    color: 'redesignPrimaryDarken',
    title: 'Привязать',
  },
  [ROW_ACTION_KEY.unlink]: {
    icon: '$iexit',
    color: 'redesignPrimaryDarken',
    title: 'Отвязать',
  },
  [ROW_ACTION_KEY.upload]: {
    icon: '$iplus-outline',
    color: 'redesignPrimaryDarken',
    title: 'Загрузить файлы',
  },
  [ROW_ACTION_KEY.confirm]: {
    color: 'redesignPrimaryDarken',
    title: 'Подтвердить',
  },
  [ROW_ACTION_KEY.date]: {
    icon: '$icalendar',
    color: 'redesignPrimaryDarken',
    title: 'Добавить дату',
  },
  [ROW_ACTION_KEY.reset]: {
    icon: '',
    color: 'redesignSecondary',
    title: 'Сбросить',
  },
};

export const TELEGRAM_BOT_URL = {
  dev: 'https://t.me/eventDevTestBot',
  prod: 'https://t.me/events_pfdo_bot',
};

export const DIALOG_MAX_WIDTH = 560;

export const LIST_SKELETON_COUNT = 6;

export const DIRECTORY_MEMBER_TYPE = {
  children: 1, // childrenAge, childrenClass
  students: 2, // highEducation
  adult: 3, // adultsAge, education
};

export const DIRECTORY_USER_ATTRIBUTE_TITLE = {
  age: 'Возраст',
  education: 'Уровень образования',
  course: 'Курс',
  class: 'Класс',
};

export const DIRECTORY_ID = {
  childrenAge: 3, // возраст от 1 до 18
  adultAge: 9, // возраст от 18 до 99
  education: 10, // уровень образования
  highEducation: 11, // курс от 1 до 5, бакалавриат, магистратура
  childrenClass: 12, // класс от 1 до 11
  classSymbol: 13, // литера класса от а до т
};

export const DIRECTORY_TITLE = {
  [DIRECTORY_ID.childrenAge]: 'Возраст',
  [DIRECTORY_ID.adultAge]: 'Возраст',
  [DIRECTORY_ID.education]: 'Уровень образования',
  [DIRECTORY_ID.highEducation]: 'Курс',
  [DIRECTORY_ID.childrenClass]: 'Класс',
  [DIRECTORY_ID.classSymbol]: 'Литера класса',
};

export const DIRECTORY_AGE_ATTRIBUTES_IDS = [DIRECTORY_ID.childrenAge, DIRECTORY_ID.adultAge];

export const PANEL_TEXT_INPUT_COMPONENT_KEY = {
  textInput: 'text-input',
  snils: 'snils-input',
  phone: 'phone-input',
  inn: 'inn-input',
};
